module.exports = __webpack_public_path__ + "img/guarana-antarctica-512.75d733d4.png";